export interface ContactListView {
  id: string;
  name: string;
  filters: Record<string, string[]>;
  sort?: {
    key: string;
    direction: 'asc' | 'desc';
  };
}

// "Don't call" contacts are excluded from every call list
const notDontCall = {
  callFlag: ['exclude-dont-call']
};

export const callListViews: ContactListView[] = [{
  id: 'lapsed-to-call',
  name: 'Lapsed buyers to call',
  filters: {
    cadenceStatus: ['lapsed'],
    hasPhone: ['yes'],
    lastContacted: ['not-30'],
    ...notDontCall
  },
  sort: {
    key: 'ltv',
    direction: 'desc'
  }
}, {
  id: 'top-not-contacted',
  name: 'Top customers not contacted in 60 days',
  filters: {
    callFlag: ['top-customer'],
    lastContacted: ['not-60']
  }
}, {
  id: 'buying-less',
  name: 'Buying less',
  filters: {
    spendTrend: ['down-20'],
    ...notDontCall
  }
}, {
  id: 'payment-problems',
  name: 'Payment problems',
  filters: {
    paymentProblem: ['yes'],
    ...notDontCall
  }
}, {
  id: 'never-contacted',
  name: 'Never contacted, with phone',
  filters: {
    lastContacted: ['never'],
    hasPhone: ['yes'],
    ...notDontCall
  }
}, {
  id: 'one-time-to-club',
  name: 'One-time buyers to convert to club',
  filters: {
    status: ['Paused', 'Cancelled'],
    oneTimeOrders: ['n2'],
    ...notDontCall
  }
}];
